import type { ServerConnection } from "@/context/server"
import { authTokenFromCredentials } from "./server"

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const result = reader.result as string
      const base64 = result.split(",")[1] ?? ""
      resolve(base64)
    }
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(file)
  })
}

export async function uploadFile(
  server: ServerConnection.HttpBase,
  targetPath: string,
  file: File,
  directory?: string,
): Promise<{ success: boolean; path: string }> {
  const base64 = await fileToBase64(file)

  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  }
  if (server.password) {
    headers.Authorization = `Basic ${authTokenFromCredentials({ username: server.username, password: server.password })}`
  }

  const url = new URL("/file/write", server.url)
  if (directory) url.searchParams.set("directory", directory)
  const res = await fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify({
      path: targetPath,
      content: base64,
      encoding: "base64",
    }),
  })

  if (!res.ok) {
    const text = await res.text().catch(() => "")
    throw new Error(`Upload failed (${res.status}): ${text}`)
  }

  const data = await res.json()
  return data
}
